import { render, staticRenderFns } from "./AnnouncementsShowDialog.vue?vue&type=template&id=4a139b24&scoped=true&"
import script from "./AnnouncementsShowDialog.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a139b24",
  null
  
)

export default component.exports